/* eslint-disable react/no-danger */
// import styles from './button.module.scss'
import { Button, type ButtonProps } from './button'

interface ButtonWithDisclaimerProps extends ButtonProps {
  disclaimer?: string
  combinedStyles?: any
}

const ButtonWithDisclaimer = ({ disclaimer, combinedStyles, ...buttonProps }: ButtonWithDisclaimerProps) => (
  <div className="buttonWithDisclaimerContainer">
    {combinedStyles && (
      <div
        id="auto-widget-button-styles"
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{ __html: combinedStyles['button.module.scss'] }}
      />
    )}
    <Button {...buttonProps} />
    {disclaimer ? <div className="buttonDisclaimer">{disclaimer}</div> : null}
  </div>
)

export default ButtonWithDisclaimer
